var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "judgmentForm",
      attrs: {
        inline: false,
        model: _vm.precheckerJudgment,
        "label-width": "150px"
      }
    },
    [
      _c("el-form-item", { attrs: { label: "Γλώσσα Αίτησης" } }, [
        _c("span", [_vm._v(_vm._s(_vm.selectedLanguage))])
      ]),
      !_vm.isPostExam
        ? _c(
            "el-form-item",
            { attrs: { label: "Εκκρεμότητες" } },
            [
              _c("el-checkbox", {
                attrs: { label: "Υπάρχουν Εκκρεμότητες", border: "" },
                on: { change: _vm.togglePending },
                model: {
                  value: _vm.precheckerJudgment.pending,
                  callback: function($$v) {
                    _vm.$set(_vm.precheckerJudgment, "pending", $$v)
                  },
                  expression: "precheckerJudgment.pending"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          !_vm.isReappraisal && !_vm.isPostExam
            ? _c(
                "el-form-item",
                { attrs: { label: "Θεματική περιοχή" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "big",
                      attrs: {
                        placeholder: "Θεματική Περιοχή",
                        filterable: "filterable"
                      },
                      on: { change: _vm.toggleAcademicField },
                      model: {
                        value: _vm.precheckerJudgment.academicField.name,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.precheckerJudgment.academicField,
                            "name",
                            $$v
                          )
                        },
                        expression: "precheckerJudgment.academicField.name"
                      }
                    },
                    _vm._l(_vm.academicAreas, function(area) {
                      return _c("el-option", {
                        key: area.id,
                        attrs: { label: area.name, value: area.id }
                      })
                    })
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isReappraisal || _vm.isPostExam
            ? _c("el-form-item", { attrs: { label: "Θεματική περιοχή" } }, [
                _vm.academicField
                  ? _c("span", [_vm._v(_vm._s(_vm.academicField.name))])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm.isReappraisal && this.workingApplication.overdue
            ? _c(
                "el-form-item",
                [
                  _c("el-alert", {
                    staticStyle: {
                      border: "1px solid",
                      "background-color": "#fdf6ec"
                    },
                    attrs: {
                      closable: false,
                      type: "warning",
                      title: _vm.OVERDUE_MESSAGE,
                      "show-icon": ""
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("hr"),
      _vm.language !== null
        ? _c("el-form-item", { attrs: { label: "Γλώσσα Χρήστη" } }, [
            _vm._v(_vm._s(_vm.language))
          ])
        : _vm._e(),
      _c("el-form-item", { attrs: { label: "Αιτησεις Χρήστη" } }, [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.calcAllApps) } })
      ]),
      !_vm.isPostExam
        ? _c("el-form-item", { attrs: { label: "Σχόλιο προς Χρήστη" } }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.generalJudgment) } })
          ])
        : _vm._e(),
      _c(
        "div",
        [
          !_vm.isPostExam
            ? _c("el-form-item", { attrs: { label: "Σχόλια Εγγράφων" } }, [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.completeDocJudgment) }
                })
              ])
            : _vm._e()
        ],
        1
      ),
      _c("hr"),
      _c("internalComments"),
      _c(
        "el-form-item",
        { attrs: { label: "Εσωτερικό Σχόλιο" } },
        [
          _c("el-input", {
            staticClass: "biggest",
            attrs: {
              type: "textarea",
              autosize: { minRows: 4, maxRows: 10 },
              placeholder: "Εισάγετε κείμενο για εσωτερική κατανάλωση"
            },
            on: { change: _vm.modifyInternalComment },
            nativeOn: {
              dblclick: function($event) {
                _vm.addText($event)
              }
            },
            model: {
              value: _vm.precheckerJudgment.internalComment,
              callback: function($$v) {
                _vm.$set(_vm.precheckerJudgment, "internalComment", $$v)
              },
              expression: "precheckerJudgment.internalComment"
            }
          })
        ],
        1
      ),
      _vm.rerouteExists
        ? _c(
            "el-form-item",
            { attrs: { label: "Σχόλιο Αναδρομολόγησης" } },
            [
              _c("el-input", {
                staticClass: "rerouteComment",
                attrs: {
                  type: "textarea",
                  size: "100",
                  disabled: true,
                  autosize: { minRows: 4, maxRows: 10 }
                },
                model: {
                  value: _vm.rerouteCom,
                  callback: function($$v) {
                    _vm.rerouteCom = $$v
                  },
                  expression: "rerouteCom"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Συνήθεις Προτάσεις",
            visible: _vm.addTextdialogVisible,
            width: "90%"
          },
          on: {
            "update:visible": function($event) {
              _vm.addTextdialogVisible = $event
            }
          }
        },
        [
          _vm._l(_vm.recommendations, function(recom) {
            return _c(
              "div",
              {
                key: recom.id,
                attrs: {
                  value: { id: recom.id, name: recom.description },
                  label: recom.description
                }
              },
              [
                _c("div", [
                  _c("label", [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: { value: recom.description, checked: false },
                      on: {
                        change: function($event) {
                          _vm.toggleText(
                            recom.id,
                            recom.description,
                            $event.target.checked
                          )
                        }
                      }
                    }),
                    _vm._v(_vm._s(recom.description))
                  ])
                ])
              ]
            )
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.addTextdialogVisible = false
                    }
                  }
                },
                [_vm._v("Άκυρο")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addTextToComment }
                },
                [_vm._v("Επιβεβαίωση")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Στην Αναμονή" } },
        [
          _c("el-checkbox", {
            attrs: { label: "Ναι", border: "" },
            on: { change: _vm.toggleQueue },
            model: {
              value: _vm.precheckerJudgment.queue,
              callback: function($$v) {
                _vm.$set(_vm.precheckerJudgment, "queue", $$v)
              },
              expression: "precheckerJudgment.queue"
            }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Χρώμα" } },
        [
          _c("el-input", {
            attrs: { placeholder: "Εισάγετε χρώμα" },
            model: {
              value: _vm.precheckerJudgment.color,
              callback: function($$v) {
                _vm.$set(_vm.precheckerJudgment, "color", $$v)
              },
              expression: "precheckerJudgment.color"
            }
          })
        ],
        1
      ),
      _c("hr"),
      _c("div"),
      _vm.isPostExam
        ? _c(
            "el-form-item",
            { attrs: { label: "Βεβαίωση από Π.Ι." } },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: this.uploadingExamResults,
                      expression: "this.uploadingExamResults"
                    }
                  ],
                  ref: "uploadExamsRef",
                  staticClass: "upload-demo",
                  attrs: {
                    accept:
                      ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF",
                    "file-list": _vm.examResultsAttachments,
                    "http-request": _vm.addExamResultsAttachment,
                    "on-preview": _vm.handlePreview,
                    "on-remove": _vm.handleExamResultsRemove,
                    "before-remove": _vm.handleBeforeRemove,
                    limit: 1,
                    action: "",
                    "auto-upload": true,
                    "show-file-list": true
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary",
                        disabled: _vm.examResultsAttachments.length >= 1
                      },
                      slot: "trigger"
                    },
                    [_vm._v("Ανέβασμα")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα Βεβαίωσης αποτελεσμάτων από Πανεπιστημιακό Ίδρυμα (Ένα αρχείο pdf μεγέθους μέχρι 12MB)"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { label: "Επιπλέον έγγραφο" } },
        [
          _c(
            "el-upload",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: this.uploadingAdditional,
                  expression: "this.uploadingAdditional"
                }
              ],
              ref: "uploadPrecheckerRef",
              staticClass: "upload-demo",
              attrs: {
                accept:
                  ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF",
                "file-list": _vm.precheckerAttachments,
                "http-request": _vm.addAdditionalAttachment,
                "on-preview": _vm.handlePreview,
                "on-remove": _vm.handleAdditionalRemove,
                "before-remove": _vm.handleBeforeRemove,
                action: "",
                "auto-upload": true,
                "show-file-list": true
              }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "trigger", size: "small", type: "primary" },
                  slot: "trigger"
                },
                [_vm._v("Ανέβασμα")]
              ),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [
                  _vm._v(
                    "** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα επιπλέον δικαιολογητικών της αίτησης (Ένα αρχείο pdf μεγέθους μέχρι 12MB)"
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Επιλογή Χειριστή" } },
        [
          _c(
            "el-select",
            {
              attrs: { filterable: "", placeholder: "Παρακαλώ Επιλέξτε" },
              on: { change: _vm.toggleSpecialProponent },
              model: {
                value: _vm.precheckerJudgment.assignedTo.uid,
                callback: function($$v) {
                  _vm.$set(_vm.precheckerJudgment.assignedTo, "uid", $$v)
                },
                expression: "precheckerJudgment.assignedTo.uid"
              }
            },
            _vm._l(_vm.specialProponents, function(specialProponent) {
              return _c("el-option", {
                key: specialProponent.id,
                attrs: {
                  label:
                    specialProponent.firstname + " " + specialProponent.surname,
                  value: specialProponent.id,
                  filterable: ""
                }
              })
            })
          )
        ],
        1
      ),
      false &&
      this.isReappraisal &&
      !this.isSecondReappraisal &&
      !this.workingApplication.overdue &&
      !_vm.precheckerJudgment.pending
        ? _c(
            "el-form-item",
            { attrs: { label: "Ανάθεση σε" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Παρακαλώ Επιλέξτε" },
                  model: {
                    value: _vm.precheckerJudgment.assignedTo.role,
                    callback: function($$v) {
                      _vm.$set(_vm.precheckerJudgment.assignedTo, "role", $$v)
                    },
                    expression: "precheckerJudgment.assignedTo.role"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "Αντιπρόεδρο Α", value: "VicePresidentA" }
                  }),
                  _c("el-option", {
                    attrs: { label: "Αντιπρόεδρο Β", value: "VicePresidentB" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { label: "" } },
        [
          _c("el-checkbox", {
            attrs: { label: "Επιθυμώ να ακυρώσω την αίτηση" },
            on: { change: _vm.toggleRelease },
            model: {
              value: _vm.releaseChecked,
              callback: function($$v) {
                _vm.releaseChecked = $$v
              },
              expression: "releaseChecked"
            }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: { effect: "dark", placement: "top" }
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  "Χρειάζεται απαραίτητα προσωρινή αποθήκευση της αίτησης"
                ),
                _c("br"),
                _vm._v(" για να ανοίξει ο διάλογος")
              ]),
              !_vm.isPostExam
                ? _c("el-checkbox", {
                    attrs: { label: "Άνοιγμα διαλόγου με πολίτη" },
                    model: {
                      value: _vm.communicationActive,
                      callback: function($$v) {
                        _vm.communicationActive = $$v
                      },
                      expression: "communicationActive"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("hr"),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "span",
            { staticStyle: { "text-align": "left" } },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "dark", placement: "top" }
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v("Προσοχή! Η αίτηση θα απενεργοποιηθεί μόνιμα"),
                    _c("br"),
                    _vm._v("και πρέπει να έχετε ανεβάσει δικαιολογητικό"),
                    _c("br"),
                    _vm._v("ή σχετικό σχόλιο")
                  ]),
                  _c(
                    "el-popover",
                    {
                      attrs: { placement: "top", width: "360" },
                      model: {
                        value: _vm.showRelease,
                        callback: function($$v) {
                          _vm.showRelease = $$v
                        },
                        expression: "showRelease"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "Είστε σίγουροι ότι θέλετε να την απενεργοποιήσετε; Αν ναι το σχόλιο για τον λόγο της απενεργοποίησης είναι υποχρεωτικό!"
                        )
                      ]),
                      _c(
                        "div",
                        { staticStyle: { "text-align": "right", margin: "0" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Σχόλιο Αποδέσμευσης",
                              type: "textarea"
                            },
                            model: {
                              value: _vm.releaseComment,
                              callback: function($$v) {
                                _vm.releaseComment = $$v
                              },
                              expression: "releaseComment"
                            }
                          }),
                          _c(
                            "p",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function($event) {
                                      _vm.showRelease = false
                                    }
                                  }
                                },
                                [_vm._v("Άκυρο")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    disabled: _vm.disableRelease
                                  },
                                  on: { click: _vm.deactivateApplication }
                                },
                                [_vm._v("Αποστολή")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "150px" },
                          attrs: {
                            slot: "reference",
                            size: "mini",
                            type: "warning",
                            round: "",
                            disabled: !_vm.releaseChecked
                          },
                          on: {
                            click: function($event) {
                              _vm.showRelease = true
                            }
                          },
                          slot: "reference"
                        },
                        [_vm._v("Ακύρωση αίτησης")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "primary",
                round: "",
                disabled: _vm.releaseChecked
              },
              on: { click: _vm.tempSave }
            },
            [_vm._v("Προσωρινή Αποθήκευση")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: !_vm.isValid || _vm.releaseChecked
              },
              on: { click: _vm.finalSave }
            },
            [_vm._v("Οριστική Υποβολή")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3cac19c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3cac19c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/PrecheckerJudgment.vue
// module id = null
// module chunks = 